import { createApi } from '@reduxjs/toolkit/query/react'
import { SERVICE_STATUS_ADD, SERVICE_STATUS_DELETE, SERVICE_STATUS_EDIT, SERVICE_STATUS_LISTING, SERVICE_STATUS_VIEW } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const serviceStatusApi = createApi({
    reducerPath: 'serviceStatusApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/status",
    }),
    tagTypes: ["ServiceStatusList", "ServiceStatusDetails"],
    endpoints: (builder) => ({

        // get service status list
        getServiceStatusList: builder.query({
            query: ({ search = "", status = "", client_type = "", module = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: SERVICE_STATUS_LISTING,
                data: { search, status, client_type, module, page, limit, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ServiceStatusList"]
        }),

        // delete service status
        deleteServiceStatus: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${SERVICE_STATUS_DELETE}/${id}`
            }),
            invalidatesTags: ["ServiceStatusList", "ServiceStatusDetails"]
        }),

        // create service status
        createServiceStatus: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: SERVICE_STATUS_ADD,
                data
            }),
            invalidatesTags: ["ServiceStatusList"]
        }),

        // update service status
        updateServiceStatus: builder.mutation({
            query: ({ data, statusId }) => ({
                method: "PUT",
                url: `${SERVICE_STATUS_EDIT}/${statusId}`,
                data
            }),
            invalidatesTags: ["ServiceStatusList", "ServiceStatusDetails"]
        }),

        // chatter service status details
        serviceStatusDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${SERVICE_STATUS_VIEW}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["ServiceStatusDetails"]
        }),

    }),
})

export const {
    useGetServiceStatusListQuery,
    useDeleteServiceStatusMutation,
    useCreateServiceStatusMutation,
    useUpdateServiceStatusMutation,
    useServiceStatusDetailsQuery

} = serviceStatusApi;